// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M2.50002 13H21.5M6 4H18L22 13V21H2V13L6 4ZM10 17H10.0039V17.0039H10V17ZM6 17H6.00391V17.0039H6V17Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"widget"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 21V13H2V21H22Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.50002 13H21.5M6 4H18L22 13V21H2V13L6 4ZM10 17H10.0039V17.0039H10V17ZM6 17H6.00391V17.0039H6V17Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WidgetIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'widget',
    ref,
    icon: element,
  },
));

WidgetIcon.displayName = 'WidgetIcon';

export default WidgetIcon;
